import { Container } from "@/components/ListenPage/Container";


export function VaultLayout({ children }) {
  return (
    <>
      <Container>
        {children}
      </Container>
    </>
  );
}
